import { useMutation } from '@maui/react-query'
import { useMatiApiClient } from './client'
import { useQuery } from '../../utils/helpers'

export const normalizeDPList = (data) => (
  data?.map((profile) => ({
    ...profile,
    displayName: profile.name,
    reportType: 'Report Digest'
  }))
    .sort((a, b) => a.name.localeCompare(b.name))
)

export const normalizeProfile = (data) => data && ({
  ...data,
  format: [data.format !== 'HTML' ? 'format' : ''],
  enableDayLightSavings: [data.enableDayLightSavings ? 'dst' : '']
})

const adapters = {
  default: normalizeDPList,
  profile: normalizeProfile,
  raw: (data) => data,
}

export const useDeliveryProfilesQuery = (options = {}) => {
  const api = useMatiApiClient('deliveryProfiles')
  return useQuery({
    queryFn: () => api.fetchAll(),
    queryKey: ['allDeliveryProfiles'],
    adapters,
    ...options
  })
}

export const useDeliveryProfileQuery = (id, options = {}) => {
  const api = useMatiApiClient('deliveryProfiles')
  return useQuery({
    queryFn: () => api.fetchProfile({ id }),
    queryKey: ['deliveryProfile', id],
    adapters,
    ...options
  })
}

export const useCreateDeliveryProfileMutation = (options = {}) => {
  const api = useMatiApiClient('deliveryProfiles')
  return useMutation({
    mutationFn: (profile) => api.createProfile({ profile }),
    invalidateKeys: ['allDeliveryProfiles'],
    ...options
  })
}

export const useUpdateDeliveryProfileMutation = (id, options = {}) => {
  const api = useMatiApiClient('deliveryProfiles')
  return useMutation({
    mutationFn: (profile) => api.updateProfile({ id, profile }),
    optimisticUpdateKey: ['deliveryProfile', id],
    optimisticUpdateFn: (oldData, newData) => {
      return {
        ...oldData,
        ...newData
      }
    },
    invalidateKeys: ['allDeliveryProfiles'],
    ...options
  })
}

export const useActivateDeliveryProfileMutation = (options = {}) => {
  const api = useMatiApiClient('deliveryProfiles')
  return useMutation({
    mutationFn: (payload) => api.activateProfile(payload),
    invalidateKeys: ['allDeliveryProfiles'],
    ...options
  })
}

export const useDeleteDeliveryProfileMutation = (id, options = {}) => {
  const api = useMatiApiClient('deliveryProfiles')
  return useMutation({
    mutationFn: () => api.deleteProfile({ id }),
    invalidateKeys: ['allDeliveryProfiles'],
    ...options
  })
}
